// (2026-07-02) SENIAT Fase 1: servicio de catálogos oficiales SENIAT
// (documento GGTIC.GIT.00.02 v1.4) y del maestro de impuestos.
// SOLO LECTURA: la edición de los catálogos se realiza directamente
// en base de datos (no hay endpoints de escritura).
import api from "./axiosConfig";

// Los 21 catálogos del documento GGTIC.GIT.00.02 v1.4.
// Backend: GET /api/seniat/catalogos (JWT; SOLO admin/auditor — otros
// roles reciben 403). Respuesta: { documento, total, catalogos: [
//   { numero, nombre, fuente: 'bd'|'codigo', columnas: [...], valores: [...] } ] }.
// Soporta { numero: N } para traer un solo catálogo.
export const getCatalogosSeniat = async (filters = {}) => {
  try {
    const params = {};
    if (filters.numero != null) params.numero = String(filters.numero);
    const response = await api.get("/api/seniat/catalogos", { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener catálogos SENIAT:", error);
    throw error;
  }
};

// (2026-08-02, ítem 28-iii) Catálogo SENIAT PÚBLICO, uno por endpoint:
// GET /api/catalogos/<slug> (seniat_routes.py:1558-1611). A diferencia de
// /api/seniat/catalogos (agregado de los 21, admin/auditor -> 403 para
// operadores), estos NO requieren rol: son datos regulatorios de referencia.
// Se usa para el Catálogo 7 en los formularios de Cliente y Empresa, donde el
// endpoint admin devolvía 403 permanente a los operadores y el formulario caía
// al fallback en silencio.
// Respuesta: { numero, nombre, fuente, columnas, valores: [...] }.
// `fuente`: 'bd' (tabla) | 'codigo' (constante normativa) | 'vacio' | 'error'.
export const getCatalogoPublico = async (slug) => {
  try {
    const response = await api.get(`/api/catalogos/${slug}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el catálogo público '${slug}':`, error);
    throw error;
  }
};

// Maestro de impuestos (todas las tasas del sistema).
// Backend: GET /api/seniat/impuestos (JWT, cualquier rol autenticado).
// Respuesta: { iva: [...], igtf: [...], otros: {...} }.
export const getMaestroImpuestos = async () => {
  try {
    const response = await api.get("/api/seniat/impuestos");
    return response.data;
  } catch (error) {
    console.error("Error al obtener el maestro de impuestos:", error);
    throw error;
  }
};
